// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__3yjS7","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__2pHBt"};